const groupWithSpaces = (digits: string): string => digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const formatRand = (value: number): string => {
	if (!value) {
		return '-';
	}

	const rounded = Math.round(Math.abs(value)).toString();
	return `${value < 0 ? '-' : ''}R ${groupWithSpaces(rounded)}`;
};

export const groupRandInput = (raw: string): string => {
	const [intPart, ...rest] = raw.split('.');
	const decimals = rest.length ? `.${rest.join('')}` : '';
	return groupWithSpaces(intPart) + decimals;
};

export const parseRandInput = (raw: string): number => parseFloat(raw.replace(/[^0-9.]/g, '')) || 0;

export const formatPercentage = (value: number): string => `${value.toFixed(1)}%`;

export const formatRatioTotal = (value: number): string => `${parseFloat(value.toFixed(2))}%`;

export const formatWeightingPoints = (value: number): string => value.toFixed(2);
